import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail, Clock } from 'lucide-react';

const Footer = () => {
  const handleCall = () => {
    window.location.href = 'tel:+33978802623';
  };

  const handleDirections = () => {
    window.open('https://www.google.com/maps/search/?api=1&query=1+Place+du+18+Novembre+1944,+90600+Grandvillars', '_blank');
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center">
                <img 
                  src="https://customer-assets.emergentagent.com/job_epicerie-copy/artifacts/v7cxe0l9_LE%20LOGO%20DE%20FACEBOOK.png" 
                  alt="IL TRULLO Logo"
                  className="w-12 h-12 object-contain"
                />
              </div>
              <div>
                <div className="font-bold text-xl" style={{ fontFamily: 'Libre Baskerville, serif' }}>IL TRULLO</div>
                <div className="text-xs text-gray-400">L'épicerie fine italienne</div>
              </div>
            </div>
            <p className="text-sm text-gray-400 mb-4">
              Sélection de produits italiens de qualité. Fabrication de pâtes fraîches maison sur place.
            </p>
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center w-10 h-10 bg-blue-600 rounded-full hover:bg-blue-700 transition-colors"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Libre Baskerville, serif' }}>Contact</h3>
            <div className="space-y-3 text-sm">
              <button onClick={handleCall} className="flex items-center gap-2 text-gray-300 hover:text-white transition-colors">
                <Phone className="w-4 h-4 text-red-500" />
                +33 9 78 80 26 23
              </button>
              <button onClick={handleDirections} className="flex items-start gap-2 text-gray-300 hover:text-white transition-colors text-left">
                <MapPin className="w-4 h-4 text-green-500 flex-shrink-0 mt-1" />
                <span>1 Place du 18 Novembre 1944,<br />90600 Grandvillars</span>
              </button>
              <Link to="/contact" className="flex items-center gap-2 text-gray-300 hover:text-white transition-colors">
                <Mail className="w-4 h-4 text-blue-500" />
                Formulaire de contact
              </Link>
            </div>
          </div>

          {/* Horaires */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Libre Baskerville, serif' }}>Horaires</h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-400">Mardi-Vendredi</span>
                <span className="text-green-400">09:00-18:30</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-400">Samedi</span>
                <span className="text-green-400">09:00-17:30</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-400">Dimanche-Lundi</span>
                <span className="text-red-400">Fermé</span>
              </div>
              <p className="text-xs text-gray-500 mt-3">* Horaires susceptibles d'évoluer</p>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <p>© 2024 IL TRULLO — L'épicerie fine italienne de Grandvillars — Tous droits réservés.</p>
            <div className="flex gap-6 mt-4 md:mt-0">
              <Link to="/mentions-legales" className="hover:text-white transition-colors">
                Mentions légales
              </Link>
              <Link to="/politique-confidentialite" className="hover:text-white transition-colors">
                Politique de confidentialité
              </Link>
              <Link to="/rgpd" className="hover:text-white transition-colors">
                RGPD
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;